const permissions = {
  dashboard: 'WP034'
};

export default permissions;
